import { Grid, Typography } from 'material-ui'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { ClientQuote } from '../components/ClientQuote'
import { Footer } from '../components/Footer'
import { ProjectSelectorCard, ProjectSelectorTitle } from '../components/ProjectSelectorCard'
import { SpreadBody } from '../components/SpreadBody'
import { AsideBox } from './AsideBox'
import { MainBlurb } from './MainBlurb'
import { TitleSpread, TitleSpreadBody, TitleSpreadContent } from './TitleSpread'

interface Props {}

interface State {

}

export class XprizeStory extends React.Component<RouteComponentProps<Props, {}>, State> {
    componentDidMount() {
        window.scroll(0, 0)
    }

    XprizeTitleSpread = () => {
        return (
            <TitleSpread
                img='/img/xprize-story/xprize-gold-photo-bg.png'
                color='#36426a'
                goBack={() => this.props.router.push('/')}
            >
                <TitleSpreadBody>
                    <TitleSpreadContent
                        sub='Partner Story'
                        title={'Barbara Bush Foundation Adult Literacy XPRIZE ' +
                        'presented by Dollar General Literacy Foundation'}
                    >
                        With results that have literally sent people out of this world, the Adult Literacy XPRIZE
                        designs prize competitions to solve the Grand Challenges of our time. Twenty Ideas has worked
                        with XPRIZE on their $7,000,000 Adult Literacy prize designing, architecting, and implementing
                        the technology backbone used to conduct the prize.
                    </TitleSpreadContent>
                </TitleSpreadBody>
            </TitleSpread>
        )
    }

    Summary = () => {
        return (
            <SpreadBody>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Improving literacy with a big payoff. $7 million to be exact.'>
                            TwentyIdeas was asked by Adult Literacy XPRIZE to collaborate on the initial strategic
                            planning and UX and UI design. From there, we built the LiteracyNow App, the analytics SDK
                            that's included within all semifinalist Apps, and the corresponding scalable analytics
                            platform.
                        </MainBlurb>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <AsideBox
                            greyBg
                            title='Learn more about the competition'
                            href='https://adultliteracy.xprize.org/'
                            linkText='Visit competition site  →'
                        >
                            The Adult Literacy XPRIZE competition puts "learning tools in the hands of those who need
                            them most, so learning can happen anytime, anywhere."
                        </AsideBox>

                    </Grid>

                    <Grid item xs={12}>
                        <img
                            src='/img/xprize-story/xprize-summary-graphic.png'
                            width={'100%'}
                            style={{marginTop: 40}}
                            alt='xprize-summary-graphic'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    AndroidApp = () => {
        return (
            <SpreadBody bottom={30}>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='One app to rule them all.'>
                            Twenty Ideas designed and built the LiteracyNow App to welcome, to screen, and to setup
                            potential prize participants. As a native Android App, LiteracyNow support multiple
                            languages, embedded video, audio notifications, and transitions to randomly assigned
                            semifinalist apps,
                        </MainBlurb>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <AsideBox
                            greyBg
                            title='Download the Literacy Now App'
                            href='https://play.google.com/store/apps/details?id=com.analyticspot.xprize.partners'
                            linkText='Literacy Now on Google Play →'
                        >
                            The LiteracyNow app allows study participants to access the app they will be studying.
                        </AsideBox>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6} sm={4}>
                        <img
                            src='/img/xprize-story/xprize-android-1.png'
                            width={'100%'}
                            style={{marginTop: 40}}
                            alt='xprize-android-screenshot'
                        />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <img
                            src='/img/xprize-story/xprize-android-2.png'
                            width={'100%'}
                            style={{marginTop: 40}}
                            alt='xprize-android-screenshot'
                        />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <img
                            src='/img/xprize-story/xprize-android-3.png'
                            width={'100%'}
                            style={{marginTop: 40}}
                            alt='xprize-android-screenshot'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    ShlomyQuote = () => {
        const quote = '"Twenty Ideas has been a critical and tremendous ' +
            'partner throughout our work on the Adult Literacy XPRIZE. ' +
            'Mike and the team are true thought partners who are consistently able to find ' +
            'the optimal technical solutions to operational challenges and to apply a strategic mindset to ' +
            'everything they do. XPRIZE competitions present grand challenges to competing teams, but they also ' +
            'represent implementational challenges to the XPRIZE team. Having Twenty Ideas as our collaborators ' +
            'in this effort has made all the difference."'
        return (
            <SpreadBody greyBg>
                <ClientQuote
                    clientName='Shlomy Kattan'
                    clientTitle='Senior Director, Learning and Human Potential, XPRIZE Foundation'
                    clientImg='/img/headshots/shlomy.png'
                    quote={quote}
                />
            </SpreadBody>
        )
    }

    AdminDashboard = () => {
        return (
            <SpreadBody top={30} bottom={40}>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='A platform of educational analytics with a side of SDK.'>
                            By building a comprehensive analytics platform, TwentyIdeas monitors, synthesizes and
                            reports usage across all the semi-finalists applications. Each semifinalist incorporated our
                            custom SDK (software development kit) to send relevant, realtime, and consistent
                            information.
                        </MainBlurb>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/xprize-story/xprize-admin-dash-1.png'
                            width={'100%'}
                            style={{marginTop: 40}}
                            alt='xprize-android-screenshot'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/xprize-story/xprize-admin-dash-2.png'
                            width={'100%'}
                            style={{marginTop: 40}}
                            alt='xprize-android-screenshot'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    OtherStories = () => {
        return (
            <SpreadBody top={40}>
                <Typography type='display1' style={{margin: '20px 0px', fontWeight: 500}}>
                    See our other partner stories
                </Typography>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <ProjectSelectorCard
                            img='/img/partner-link-photo-green.png'
                            color='#36426a'
                            height={300}
                            onClick={() => this.props.router.push('/random-lengths')}
                        >
                            <ProjectSelectorTitle title='Random Lengths' sub='Pioneer of Wood Products Info'/>
                        </ProjectSelectorCard>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ProjectSelectorCard
                            img='/img/avant-link-photo-blue.png'
                            color='#36426a'
                            height={300}
                            onClick={() => this.props.router.push('/avant')}
                        >
                            <ProjectSelectorTitle title='Avant Assessment' sub='Leader in Language Assessment'/>
                        </ProjectSelectorCard>
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    render() {
        const {XprizeTitleSpread, Summary, AndroidApp, ShlomyQuote, AdminDashboard, OtherStories} = this

        return (
            <div>
                <XprizeTitleSpread/>
                <Summary/>
                <ShlomyQuote/>
                <AndroidApp/>
                <AdminDashboard/>
                <OtherStories/>
                <Footer accent navigateTo={this.props.router.push}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/stories/XprizeStory.tsx